









































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import _ from 'lodash';
import TreeState from '../models/TreeState';
import SourceView from './SourceView.vue';
import TDVOptions, { ParserPlugin } from '../models/TDVOption';
import TreeView from './TreeView.vue';
import JsonTable from './JsonTable.vue';
import JSONParserPlugin from '../parsers/JSONParserPlugin';

import { TDNode, TDJSONWriter, TDJSONWriterOption } from 'treedoc';
import { NodeMouseEnterEvent } from './TreeViewItem.vue';
import { nextTick } from 'vue/types/umd';

@Component({
  components: {
    TreeView,
    JsonTable,
    SourceView,
  },
})
export default class JsonTreeTable extends Vue {
  @Prop() title?: string;
  @Prop() data!: object | any[] | string;
  @Prop() options?: TDVOptions;
  @Prop() initalPath!: string;
  @Prop() rootObjectKey!: string;
  @Prop() initialDataParser?: string | null;
  @Prop({ default: 1 }) defaultExpandLevel?: number;

  defaultParser: ParserPlugin<any> = new JSONParserPlugin();
  selectedParser: ParserPlugin<any> = this.defaultParser;
  useInitialDataParser: boolean = !!this.initialDataParser;
  tstate = new TreeState({}, this.selectedParser).setInitSOpt(this.options);
  jsonStr = '';

  parseResult = '';
  strDataSynced = false;
  error = {
    color: 'red',
  };

  // url = https://maps.sensor.community/data/v2/data.24h.json
  // url = 'https://jsonplaceholder.typicode.com/posts';
  url = 'https://www.googleapis.com/discovery/v1/apis/vision/v1p1beta1/rest';
  // url = "https://www.googleapis.com/discovery/v1/apis"
  urlInput = '';

  treeItemActionStyle = {};
  mouseEnterEvent: NodeMouseEnterEvent | null = null;
  mouseInActionBarRealtime = false;
  mouseInActionBar = false;
  mouseInNode = false;

  nodeClicked(nodePath: string[]) {
    this.tstate.select(nodePath);
  }

  format() {
    this.jsonStr = TDJSONWriter.get().writeAsString(this.tstate.tree.root, new TDJSONWriterOption().setIndentFactor(2));
  }

  created() {
    if (this.initialDataParser) {
      this.selectedParser = this.parserSelectOptions?.find(o => o.value.syntax === this.initialDataParser)?.value || this.selectedParser;
    }
  }

  mounted() {
    // for devtool interaction
    (window as any).tdv = this;
  }

  onKeyPress(e: KeyboardEvent, pane: string) {
    // console.log(e);
    // Very strange: In source page, for 'f' key it will send to div first, then to editor. But for ctrl-f, 
    // it will send to editor first and it preventDefault(), so the hot key won't work. We disable hot key for source page for now.
    if (pane === 'source')
      return;  // The source pane the key event won't reach editor before the div
    if (e.key === 'f') {
      this.tstate.toggleMaxPane(pane);
      // e.preventDefault();
    } else if (e.key === 'w') {
      this.tstate.textWrap = !this.tstate.textWrap
      // e.preventDefault();
    } else if (e.key === '[') {
      this.tstate.back()
      // e.preventDefault();
    } else if (e.key === ']') {
      this.tstate.forward()
      // e.preventDefault();
    }
  }

  // for devtool interaction only
  transformJson(func: (obj: any) => any) {
    this.jsonStr = JSON.stringify(func(this.tstate.tree.root.toObject(true)), null, 2);
  }

  @Watch('data', { immediate: true })
  private watchData(d: string | object | any[]) {
    if (_.isString(d))
      this.jsonStr = d;
    else {
      this.jsonStr = JSON.stringify(d, null, '  ');
      this.strDataSynced = true;
    }
  }

  @Watch('selectedParser')
  private watch(v: ParserPlugin<any>) {
    this.parse(this.jsonStr, this);
  }

  @Watch('jsonStr', { immediate: true })
  private watchJsonStr(str: string, old: string) {
    if (!str)
      str = '';

    if (str.length > 200_000)
      this.tstate.codeView[0] = false;
    if (str.length < 100_000)
      this.tstate.codeView[0] = true;
    // Need detected only if significant changes happens. Not accurate.
    const oldLen = old ? old.length : 0;
    const detectNeeded = Math.abs(oldLen - str.length) > 7 && !this.useInitialDataParser;
    this.useInitialDataParser = false;
    this.parse(str, this, detectNeeded);
  }

  // Have to pass THIS as Vue framework will generate a different instance
  // of this during runtime.
  private parse = _.debounce((str: string, THIS: JsonTreeTable, detectParser = false) => {
    // Auto detect parser
    if (detectParser) {
      THIS.selectedParser = this.parserSelectOptions[0].value;  // Default to first parser
      for (const parser of this.parserSelectOptions) {
        if (parser.value.looksLike(str)) {
          THIS.selectedParser = parser.value;
          break;
        }
      }
    }

    const selectedPath = THIS.tstate.selected ? THIS.tstate.selected.path : [];
    THIS.tstate = new TreeState(this.strDataSynced ? THIS.data : str, THIS.selectedParser, THIS.rootObjectKey, selectedPath).retainState(THIS.tstate);
    THIS.strDataSynced = false;
    THIS.parseResult = THIS.tstate.parseResult;

    if (selectedPath.length === 0 && THIS.initalPath && THIS.tstate.tree)
      THIS.tstate.select(THIS.initalPath, true);
  }, 300);

  get hasError() {
    return this.parseResult.startsWith('Error');
  }

  get tableOpt() {
    return this.options?.defaultTableOpt;
  }

  get parserSelectOptions() {
    const opt = new Array<{text: string, value: ParserPlugin<any>}>();
    opt.push({ text: this.defaultParser.name, value: this.defaultParser });
    if (this.options && this.options.parsers)
      this.options.parsers.forEach(p => opt.push({text: p.name, value: p}));
    return opt;
  }
  
  get copyTextArea() { return this.$refs.copyTextArea as HTMLTextAreaElement; }
  get sourceView() { return this.$refs.sourceView as SourceView; }

  readFile(ef: Event) {
    const fileName = (ef.target as HTMLInputElement).files![0];
    if (!fileName)
      return;
    const reader = new FileReader();
    reader.onload = (e: Event) =>  {
      if (reader.result)
        this.jsonStr = reader.result as string;
    };
    reader.readAsText(fileName);
  }

  openUrl(dataUrl: string) {
    this.url = dataUrl;
    window.fetch(this.url)
      .then(res => res.text())
      .then(data => this.jsonStr = data)
      .catch((err) => this.jsonStr = err);
    this.jsonStr = JSON.stringify({
      action: 'loading...',
      url: this.url,
    }, null, 2);
  }

  get pasteSupported() { return !!navigator?.clipboard?.readText; }

  paste() {
    // this.copyTextArea.select();
    // this.copyTextArea.focus();
    // // Doesn't work both in firefox and chrome
    // const res = document.execCommand('paste');
    // console.log(`paste result: ${res}`);

    // Only works for chrome
    navigator.clipboard.readText().then((txt: string) => {
       this.jsonStr = txt;
    });
  }


  copyText(text: string) {
    // code mirror doesn't support copy command, we have to use a hidden textarea to do the copy
    this.copyTextArea.value = text;
    this.copyTextArea.select();
    this.copyTextArea.setSelectionRange(0, 999999999);
    // document.execCommand('selectAll');
    const res = document.execCommand('copy');
    console.log(`copy result: ${res}`);
    // this.codeView.editor.getTextArea().select();
    // this.codeView.editor.execCommand('selectAll');
    // this.codeView.editor.execCommand('copy');
  }

  get mouseOverNode() { return this.tstate.findNodeByPath(this.mouseEnterEvent!.nodePath); }
  
  copyNode() { 
    const node = this.mouseOverNode;
    if (node.start && node.end)
      this.copyText(this.jsonStr.substring(node.start.pos, node.end.pos));
    else 
      this.copyText(TDJSONWriter.writeAsString(node, new TDJSONWriterOption().setIndentFactor(2)));
  }

  nodeMouseEnter(e: CustomEvent) { 
    this.mouseEnterEvent = e.detail; 
    this.mouseInNode = true;
    const pos = this.mouseEnterEvent!.source.getBoundingClientRect();
    this.treeItemActionStyle = {position: 'fixed', top: `${pos.top}px`, left: `${pos.right}px`};
  }

  nodeMouseLeave(e: CustomEvent) {
    if (this.mouseEnterEvent?.source === e.detail.source)
      this.mouseInNode = false;
  }

  mouseEnterActionBar() {
    this.mouseInActionBarRealtime = true;
    setTimeout(() => this.mouseInActionBar = true, 500);
  }

  mouseLeaveActionBar() {
    this.mouseInActionBarRealtime = false;
    setTimeout(() => {
      if (!this.mouseInActionBarRealtime)
        this.mouseInActionBar = false;
    }, 500);
  }
}
